import React from 'react'
import ProjectData from "../api/project-data"
import RelatedProjects from "../sections/related-project"

class Project extends React.Component {
    constructor(){
        super();
        this.state={
            active: "false"
        }
    }

    componentDidMount(){
        setTimeout(() => {
            this.setState({
                active: "true"
            })
        }, 500);
    }

    componentDidUpdate(){
        this.refs.video.load()
        window.scrollTo(0,0);
    }

    componentWillUnmount(){
        this.setState({
            active: "false"
        })
    }
    render(){
        let project_id = this.props.id;
        const project = ProjectData.projects.find(({ id }) => id === project_id)
        return(
            <main activepage={this.state.active}>
            <section>
                <div className="gc big-spacing">
                    <div className="d-1-13 m-span-all">
                        <video ref="video" playsinline controls title={project.title}>
                        <source src={project.video}></source>
                        </video>
                    </div>
                    <div className="d-1-7 m-1-13 text-right">
                        <h1>{project.title.toUpperCase()}</h1>
                    </div>
                    <div className="d-7-13 m-1-13 m-span-all">
                        <div dangerouslySetInnerHTML={{__html: project.description }}></div>
                    </div>
                </div>
            </section>
            <RelatedProjects />
            </main>
        )
    }
}

export default Project